/**
 * Width of the transparent border every MUI Tab gets (see _base.overrides).
 * Shared with selectedTabCorners, which has to place its corners outside it.
 */
export const MUI_TAB_BORDER_PX = 2;
